module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-PJ.1fa2e54b.png";